import { gql } from "@apollo/client"
import styled from "@emotion/styled"
import { Button, mq, Text, theme } from "@pallet-hq/hegel"
import { FlexColumn } from "components/atoms"
import Image from "components/Image"
import { WelcomeFullCandidatePreview_candidate } from "__generated__/WelcomeFullCandidatePreview_candidate"

const FullCandidatePreviewFragment = gql`
    fragment WelcomeFullCandidatePreview_candidate on PublicCandidateType {
        id
        anonymousHeadline
        anonymousProfileImage
        anonymousPreferencesSummary
    }
`

type FullCandidatePreviewProps = {
    candidate: WelcomeFullCandidatePreview_candidate
}

const FullCandidatePreview = ({ candidate }: FullCandidatePreviewProps) => {
    return (
        <Wrapper>
            <ImageWrapper>
                <Image
                    src={candidate.anonymousProfileImage}
                    width={64}
                    height={64}
                    borderRadius="100%"
                    alt={candidate.anonymousHeadline}
                    colorSlug=""
                />
            </ImageWrapper>
            <CandidateInfo>
                <Text variant="headlineSmall" mb="xsmall" mt={["small", "0"]}>
                    {candidate.anonymousHeadline}
                </Text>
                <Text variant="paragraphMedium">
                    {candidate.anonymousPreferencesSummary}
                </Text>
            </CandidateInfo>
            <Button
                variant="secondary"
                size="small"
                ml="auto"
                mt={["small", "0"]}
                width={["100%", "auto"]}
                disabled
            >
                Request to chat
            </Button>
        </Wrapper>
    )
}

FullCandidatePreview.fragment = FullCandidatePreviewFragment
export default FullCandidatePreview

const Wrapper = styled.div`
    padding: ${theme.space.medium};
    display: flex;
    align-items: center;
    border: 1px solid ${theme.colors.gray300};
    border-bottom-width: 0;

    ${mq({ flexDirection: ["column", "row"] })};
`

const ImageWrapper = styled.div`
    margin-right: ${theme.space.small};
`

const CandidateInfo = styled(FlexColumn)`
    ${mq({ marginRight: [0, theme.space.small] })};
`
